/**
 * Plan 140: Tracks in-flight quick actions per (clauseId|documentId, actionId)
 * so the UI can disable buttons and render skeletons.
 */
import { create } from 'zustand';

interface QuickActionState {
  inFlight: Record<string, Set<string>>; // targetId -> Set<actionId>
  start: (targetId: string, actionId: string) => void;
  finish: (targetId: string, actionId: string) => void;
  isInFlight: (targetId: string, actionId: string) => boolean;
  hasAnyInFlight: (targetId: string) => boolean;
}

export const useQuickActionStore = create<QuickActionState>((set, get) => ({
  inFlight: {},
  start: (targetId, actionId) =>
    set((s) => {
      const next = { ...s.inFlight };
      const set_ = new Set(next[targetId] ?? []);
      set_.add(actionId);
      next[targetId] = set_;
      return { inFlight: next };
    }),
  finish: (targetId, actionId) =>
    set((s) => {
      const next = { ...s.inFlight };
      const set_ = new Set(next[targetId] ?? []);
      set_.delete(actionId);
      if (set_.size === 0) delete next[targetId];
      else next[targetId] = set_;
      return { inFlight: next };
    }),
  isInFlight: (targetId, actionId) =>
    Boolean(get().inFlight[targetId]?.has(actionId)),
  hasAnyInFlight: (targetId) => (get().inFlight[targetId]?.size ?? 0) > 0,
}));
